import type { ReactNode } from 'react';
import { Text } from '@bridebook/aura';
import { SupplierVideoEmbed } from '@bridebook/web/app-shared/components/supplier/video/supplier-video-embed';

interface IProps {
  heading: string;
  descriptionShort?: string;
  embedUrl: string;
  videoTitle: string;
  videoDescription?: string;
  breadcrumbs?: ReactNode;
  // Back-to-profile and enquiry buttons; each app supplies its own routing/enquiry variants.
  actions: ReactNode;
}

export const SupplierVideoBody = ({
  heading,
  descriptionShort,
  embedUrl,
  videoTitle,
  videoDescription,
  breadcrumbs,
  actions,
}: IProps) => (
  <div className="mx-auto w-full max-w-[860px] px-4 py-6">
    {breadcrumbs}

    <Text as="h1" className="mb-3 text-[28px] leading-[120%] font-semibold">
      {heading}
    </Text>

    {descriptionShort && <Text className="mb-2 whitespace-pre-wrap">{descriptionShort}</Text>}

    <SupplierVideoEmbed
      embedUrl={embedUrl}
      title={heading}
      videoTitle={videoTitle}
      videoDescription={videoDescription}
    />

    <div className="flex flex-col-reverse gap-3 sm:flex-row sm:flex-wrap">{actions}</div>
  </div>
);
